var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4252 0H2.58594C2.26234 0 2 0.262344 2 0.585938V19.4141C2 19.7377 2.26234 20 2.58594 20H17.4252C17.7488 20 18.0111 19.7377 18.0111 19.4141V0.585938C18.0111 0.262344 17.7488 0 17.4252 0ZM16.8392 18.8281H3.17188V1.17188H16.8393V18.8281H16.8392Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92969 17.6562H15.0814C15.405 17.6562 15.6674 17.3939 15.6674 17.0703V2.92969C15.6674 2.60609 15.405 2.34375 15.0814 2.34375H4.92969C4.60609 2.34375 4.34375 2.60609 4.34375 2.92969V17.0703C4.34375 17.3939 4.60605 17.6562 4.92969 17.6562ZM5.51562 16.4844V11.5499H6.39875C7.97996 11.5499 9.46695 12.1657 10.5853 13.2833C11.2449 13.9446 12.0191 14.4621 12.8863 14.8213C13.4029 15.0354 13.9427 15.1872 14.4955 15.2743V16.4844H5.51562ZM14.4955 3.51562V14.0844C14.0977 14.0089 13.7089 13.8938 13.3349 13.7387C12.611 13.4388 11.965 13.0071 11.4143 12.455C10.074 11.1157 8.29281 10.378 6.39875 10.378H5.51562V3.51562H14.4955Z",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27344 6.25H12.7377C13.0613 6.25 13.3236 5.98766 13.3236 5.66406C13.3236 5.34047 13.0613 5.07812 12.7377 5.07812H7.27344C6.94984 5.07812 6.6875 5.34047 6.6875 5.66406C6.6875 5.98766 6.9498 6.25 7.27344 6.25Z",
    fill: "#1F1F1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7379 7.42188H11.1777C10.8541 7.42188 10.5918 7.68422 10.5918 8.00781C10.5918 8.33141 10.8541 8.59375 11.1777 8.59375H12.7379C13.0615 8.59375 13.3238 8.33141 13.3238 8.00781C13.3238 7.68422 13.0615 7.42188 12.7379 7.42188Z",
    fill: "#1F1F1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83359 7.42188H7.27344C6.94984 7.42188 6.6875 7.68422 6.6875 8.00781C6.6875 8.33141 6.94984 8.59375 7.27344 8.59375H8.83359C9.15719 8.59375 9.41953 8.33141 9.41953 8.00781C9.41953 7.68422 9.15719 7.42188 8.83359 7.42188Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosterIcon);
export default __webpack_public_path__ + "static/media/poster-icon.7617407151352fed179a2f134de59e50.svg";
export { ForwardRef as ReactComponent };